<template lang="html">
  
  <div class="field is-horizontal" v-bind:id="id">
    <div v-if="showLabel" class="field-label is-small pl-1">
      <label class="label">{{ data.label }}</label>
    </div>
    
    <div class="field-body is-block">
      
      <span v-if="disabled">
        <a v-if="hasLinkPath()" @click="select()" :style="'text-align:'+align(data.type)">{{ fieldval }}</a>
        <p v-else :style="'text-align:'+align(data.type)">{{ filter(fieldval, data.type) }}</p>
      </span>
      
      <span v-if="!disabled">
        <div v-if="isActionable(data.type)">
          <a v-if="state == 'READY'" :href="filter( fieldval, data.type )">{{ fieldval }}</a>
          <input v-if="state != 'READY' || !fieldval" v-on:change="change" v-bind:readonly="readonly" v-bind:disabled="disabled" v-bind:value="fieldval" class="input" v-bind:type="data.type" v-bind:placeholder="data.placeholder" v-bind:class="{ 'border':disabled, 'is-success': data.success, 'is-danger': emptyField}">
        </div>
        
        <div class="field" v-if="isText(data.type)">
          <div class="control is-small">
            
            <div v-if="data.action" class="is-flex">
              <input class="input is-small is-rounded" v-model="inputField" v-bind:type="data.type" v-bind:placeholder="data.placeholder">
              <i class="fas fa-lg fa-circle-arrow-right is-align-content-center ml-2" @click="search()"></i>
            </div>
            
            <div v-if="!data.action">
              <input v-if="data.type!='textarea'" v-on:change="change" v-bind:readonly="readonly" v-bind:disabled="disabled" v-bind:value="fieldval" class="input" v-bind:type="data.type" v-bind:placeholder="data.placeholder" v-bind:class="{ 'border':disabled, 'is-success': data.success, 'is-danger': emptyField}">
              <textarea id="textarea" v-if="data.type=='textarea'" :rows="textareaRows" v-on:change="change" v-bind:readonly="readonly" v-bind:disabled="disabled" v-bind:value="fieldval" class="textarea" :type="data.type" v-bind:placeholder="data.placeholder" v-bind:class="{'border':disabled, 'is-success': data.success, 'is-danger': emptyField}"></textarea>
              <p v-if="data.success || emptyField" class="help" v-bind:class="{ 'is-success': data.success, 'is-danger': emptyField}">{{ data.message }}</p>
            </div>
          </div>
        </div>
        
        <div v-if="data.type=='currency' || data.type=='number'">  
          <input v-if="disabled" v-on:change="change" v-bind:readonly="readonly" disabled="true" v-bind:value="filter(fieldval, data.type)" class="input" :type="data.type" v-bind:placeholder="data.placeholder" v-bind:class="{ 'border':disabled, 'is-success': data.success, 'is-danger': emptyField}">
          <input v-else v-on:change="change" v-bind:readonly="readonly" v-bind:disabled="disabled" v-bind:value="fieldval" class="input" :type="data.type" v-bind:placeholder="data.placeholder" v-bind:class="{ 'border':disabled, 'is-success': data.success, 'is-danger': emptyField}">
        </div>
        
        <div v-if="data.type=='autonumber'">  
          <input disabled="true" v-bind:value="filter(fieldval, data.type)" class="input" v-bind:placeholder="data.placeholder" v-bind:class="{ 'border':disabled, 'is-success': data.success, 'is-danger': emptyField}">
        </div>
        
        <label v-if="data.type=='checkbox'" class="checkbox" >
          <input v-on:change="change" v-bind:readonly="readonly" v-bind:disabled="disabled" v-bind:value="fieldval" v-bind:type="data.type" :class="{ 'border':disabled, 'is-success': data.success, 'is-danger': emptyField}">
        </label>          
        
        <div v-if="data.type=='address'">
          <a :href="['https://maps.apple.com/?q=' + getAddress(fieldval)]" target="_blank">
            {{ getAddress(fieldval) }}
          </a>
        </div>
        
        <div v-if="data.type=='date'">
          <input type="date" v-on:change="change" v-bind:readonly="readonly" v-bind:disabled="disabled" v-bind:value="fieldval" class="input" v-bind:placeholder="data.placeholder" v-bind:class="{ 'border':disabled, 'is-success': data.success, 'is-danger': emptyField}">
        </div>
        
        <div v-if="data.type=='datetime'">
          <input type="datetime" v-on:change="change" v-bind:readonly="readonly" v-bind:disabled="disabled" v-bind:value="filter(fieldval, data.type)" class="input" v-bind:placeholder="data.placeholder" v-bind:class="{ 'border':disabled, 'is-success': data.success, 'is-danger': data.fail}">
        </div>
        
        <div v-if="data.type=='radio'" class="control">
          <label  class="radio" v-for="option in data.options" v-bind:key="option.value">
            <input v-on:change="change" v-bind:readonly="readonly" v-bind:disabled="disabled" v-bind:value="fieldval" v-bind:type="data.type" v-bind:name="data.name" >
            {{ option.label }}
          </label>
        </div>
        
        <div v-if="data.type=='picklist'" class="select is-fullwidth" style="height:auto" v-bind:class="{ 'border':disabled, 'is-success': data.success, 'is-danger': emptyField}">
          <select v-on:change="change" v-bind:readonly="readonly" v-bind:disabled="disabled" v-bind:value="fieldval">
            <option v-if="searchableField" value="" selected></option>
            <option v-for="option in picklistOptions" v-bind:key="option.value">{{ option.label }}</option>
          </select>
        </div>
        
        <div v-if="data.type=='link'">
          <a v-bind:href="fieldval" target="_blank">{{fieldval}}</a>
        </div>
        
        <div v-if="data.type=='lookup'">
          
          <span v-if="state == 'READY'">
            <a v-if="hasLinkPath()" @click="select()">{{ fieldval }}</a>
            <p v-else>{{ fieldval }}</p>
          </span>
          
          <div v-if="state != 'READY' || !fieldval" class="field has-addons" :class="{ 'pe-none':disabled }" @click="searchLookup()">
            <p class="control is-expanded">
              
              <input v-on:change="change" v-bind:readonly="true" v-bind:disabled="disabled" v-bind:value="fieldval" class="input" v-bind:type="data.type" v-bind:placeholder="data.placeholder" v-bind:class="{ 'border':disabled, 'is-success': data.success, 'is-danger': emptyField}">
              
            </p>
            <p class="control">
              <button class="button is-inverted" v-bind:disabled="disabled">
                <span class="icon"><i class="fa fa-search"></i></span>
              </button>
            </p>
          </div>
        </div>
        
        <div v-if="data.type=='dropdown'">
          <!-- OPTION TABLE -->
          <div v-if="!disabled">
            <button class="button is-fullwidth is-justify-content-space-between" :class="{ 'border-danger': emptyField }">
              <input type="search" v-model="searchTextDropdown" v-on:keyup="compilingDropdown($event)" style="width:100%" :class="{ 'border-danger': emptyField }"/>
              <span class="icon is-small"><i class="fas fa-angle-down" aria-hidden="true"></i></span>
            </button>
          </div>
          <div v-if="showDropdownRecords" class="box" style="position:absolute;z-index:1">
            <div class="dropdown-content" >
              <div class="dropdown-item">
                <table class="table is-narrow">
                  <thead>
                    <th v-for="c in dropdownFields.keys()">{{ dropdownFields.get(c).label }}</th>
                  </thead>
                  <tbody>
                    <tr v-for="rd of recordsDropdown" :key="rd.Id" @click="selectDropdownRecord(rd)">
                      <td v-for="c of dropdownFields.keys()">{{ rd[dropdownFields.get(c).name] }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          
        </div>
      </span>
      
    </div>
  </div>
  
</template>

<script>

import numeral from 'numeral'
import moment from 'moment'

export default {
  name: 'bulmaFieldInternalStore',
  components: {},
  props: {
    id: String,
    data: Object,
    table: String,
    record: Object,
    showLabel: {
      type: Boolean,
      default: true
    },
    disabledProp: Boolean,
  },
  data: function () {
    return {
      inputField: '',
      textareaRows: 0,
      
      searchTextDropdown: '',
      showDropdownRecords: false,
      recordsDropdown: [],
      dropdownInterval: undefined,
      fieldval: ''
    }
  },
  
  filters: {
  },
  
  watch: {
    inputField (input) {
      console.log('inputField: '+input, typeof(input))
    },
    record: {
      handler(newVal, oldVal) {
        if(this.data.type == 'dropdown') {
          console.log('record newVal:', newVal)
          let r = this.record
          let path = this.data.related ? this.data.related : this.data.name
          
          this.searchTextDropdown = this.getFieldValue(r, path)
        }
      },
      deep: true
    },
  },
  
  computed: {
    dropdownFields: function () {
      if (!this.dropdownData.table) return []
      if (!this.$store.state.database.has(this.dropdownData.table)) return [];
      let table=this.$store.state.database.get(this.dropdownData.table);
      
      let solvedfields = new Map()
      if(this.dropdownData.cols) {
        this.dropdownData.cols.forEach( f => {
          if (table.has(f.fieldname)) {
            if(table.get(f.fieldname).type != 'hidden') {
              let f2={ ...table.get(f.fieldname) }
              if (f.readonly) f2.readonly=f.readonly;
              solvedfields.set(f.fieldname,f2)
            }
          } else console.log('Manca '+f.fieldname+' nel SalesPaddy Database')
        });
      }
      return solvedfields;
    },
    dropdownData() {
      let dropdownVerb = this.$store.getters.getVerb( this.$store.getters.getProcess(this.data.process), this.data.verb )
      return this.$store.getters.getObject(this.$store.getters.getPage(dropdownVerb.pageid).initialid).data
    },
    disabled: function() {
      if(this.data.readonly || this.data.disabled) return true
      if(this.disabledProp) return true
      return false;
    },
    readonly: function() {
      if(this.searchableField) return false
      if (this.data.readonly) return true;
      return false;
    },
    searchableField() {
      return this.$store.getters.getRecordState == "SEARCH" && this.data.searchable
    },
    state() {
      return this.$store.getters.getRecordState;
    },
    picklistOptions() {
      var options = []
      var activeFieldval = false
      this.data.options.forEach( o => {
        options.push(o)
        if(o.value == this.fieldval) activeFieldval = true
      })
      if(!activeFieldval) options.push({ "label": '', "value": '' })
      return options;
    },
    emptyField() {
      console.log('emptyField', this.fieldval);
      if(!this.fieldval && this.data.required) return true
      return false
    },
  },
  
  mounted: function() {
    this.setFieldVal();
    
    if(this.data.type == 'dropdown') this.searchTextDropdown = this.fieldval
  },
  
  methods: {
    change: function(e) {
      console.log("change",e.target.value);
      this.setFieldVal(e.target.value);
      this.$emit('change', { recordId: this.record.Id, fields: new Map([[ this.data.name, e.target.value ]]) })
      
      if(this.searchableField) {
        if(e.target.value != '') {
          this.$store.commit('SET_ADVANCEDFILTERINGPROPERTIES',
          { 
            fieldname: this.data.name, 
            operator: this.$store.getters.getQueryOperator(this.data.type),
            value: e.target.value,
            table: this.data.table
          }
          )
        } else this.$store.commit('REMOVE_ONE_ADVANCEDFILTERINGPROPERTIES', { fieldname: this.data.name })
      }
    },
    
    search() {
      console.log('search this.data.action', this.data.action)
      let m={ message: this.data.action, payload: this.inputField};
      this.$store.commit('POST_MESSAGE', m);
    },
    
    isText: function(type) {
      if (type=='text' || type=='password' || type=='tel' || type=='textarea') return true;
      return false
    },
    
    isActionable: function(type) {
      if (type=='email' || type=='phone') return true;
      return false;
    },
    
    filter: function(v, type) {
      switch(type) {
        case 'hidden':
        return;
        case 'date':
        if (v) {
          var n=new moment(v);
          return n.format('DD/MM/YYYY');
        }
        return v;
        case 'datetime':
        if (v) {
          var n=new moment(v);
          return n.format('DD/MM/YYYY HH:mm');
        }
        return v;
        case 'decimal':
        if (v)
        return numeral(v).format('0,0');
        return v;
        case 'currency':
        if (v)
        return numeral(v).format('€ 0,0.00');
        return v;
        case 'truncate':
        if (v)
        return v.substr(0,32);
        case 'phone':
        if(v) return 'tel:'+v;
        case 'email':
        if(v) return 'mailto:'+v;
      }
      return v;
    },
    
    getAddress(value) {
      if(!value) return ''
      
      var street = ''
      if(value.street) street = value.street
      if(value.city) street += ' '+value.city
      if(value.state) street += ' '+value.state
      if(value.postalCode) street += ' '+value.postalCode
      
      return street
      
    },
    
    select: function() {
      var id = this.record[this.data.name]
      var path = this.getLinkPath(id)
      this.$router.push(`/${path}/d/${id}`);
    },
    
    getLinkPath(id) {
      // console.log('getLinkPath id', id)
      if(!id) return false
      if(id && typeof(id) != 'string') return false
      var idStart = id.slice(0,3)
      var process = this.$store.state.config.processes.find( obj => obj.recordStartWith == idStart )
      // console.log('getLinkPath process', process)
      if(process) return process.id
      return false
    },
    
    hasLinkPath() {
      var id = this.record[this.data.name]
      if(this.getLinkPath(id)) return true
      return false
    },
    
    getFieldValue: function(obj, path) {
      // eslint-disable-next-line no-redeclare
      for (var i=0, path=path.split('.'), len=path.length; i<len; i++){
        if (obj)
        obj = obj[path[i]];
      }
      return obj;
    },
    
    align: function(type) {
      switch(type) {
        case 'currency':
        case 'decimal':
        case 'number':
        return 'right';
      }
      return 'left';
    },
    
    searchLookup () {
      console.log('searchLookup')
      var data = {
        processId: this.data.process,
        verbId: this.data.verb,
        title: this.data.label,
        fieldname: this.data.name,
        related_fieldname: this.data.related,
        fieldval: this.fieldval,
        defaults: this.data.defaults,
        srcRecord: this.record
      }

      var verb = this.$store.getters.getVerb( this.$store.getters.getProcess(this.data.process), this.data.verb )
      this.$store.commit('SET_RECORDS_STATE', {id: this.data.process, state: verb.state});
      
      this.$store.commit('PUSH_PROCESS_STATUS', data);
    },
    
    compilingDropdown: function (event) {
      console.log('--> compilingDropdown')
      console.log('event', event.target.value)
      
      if (this.dropdownInterval) clearInterval(this.dropdownInterval)
      
      this.recordsDropdown = []
      this.showDropdownRecords = false
      
      if(event.target.value != '') {
        let self = this
        this.dropdownInterval = setInterval(function () {
          var s = [{
            fieldname: self.dropdownData.searchableCol.fieldname,
            operator: self.dropdownData.searchableCol.operator,
            value: (event.target.value).replaceAll(" ","%")
          }]
          console.log('s',s)
          self.loadRowsSearch(s)
          
          clearInterval(self.dropdownInterval);
        }, 500)
      }
    },
    
    loadRowsSearch: async function(f) {
      console.log('--> loadRowsSearch (bulma_table)')
      console.log('f',f)
      
      let id = this.id+'_'+this.dropdownData.table+'_writeInline'
      
      var payload={
        id: id,
        tablename: this.dropdownData.table,
        cols: this.dropdownData.cols,
        filters: f,
        childQuery: [],
        orders: this.dropdownData.order,
        offset: 0,
        limit: this.dropdownData.limit
      }
      console.log('PAYLOAD', payload)
      
      await this.$store.dispatch('load_records', payload );
      
      let data=this.$store.getters.getRecordsList(id);
      if (data) {
        if(data.totalRecords) {
          this.recordsDropdown=data.records
          this.showDropdownRecords = true
        }
      }
    },
    
    selectDropdownRecord(recordSelected) {
      console.log('--> selectDropdownRecord')
      console.log(this.record.Id, recordSelected)
      
      var e = { 
        recordId: this.record.Id,
        fields: new Map()
      }
      for(var c of this.dropdownData.cols) {
        
        if(!c.related.includes('.')) e.fields.set(c.related, recordSelected[c.fieldname])
        else {
          let parentAndField = c.related.split('.')
          
          let tmp = {}
          if(e.fields.has(parentAndField[0])) tmp = e.fields.get(parentAndField[0])
          
          tmp[parentAndField[1]] = recordSelected[c.fieldname]
          e.fields.set(parentAndField[0], tmp)
        }
      }
      console.log('e', e)
      this.$emit('change', e)
      
      this.showDropdownRecords = false
      this.searchTextDropdown = this.fieldval
    },
    
    setFieldVal: function(val) {
      let result = (val) ? val : undefined;
      if(val == undefined) {
        let r = this.record;
        let attr = this.data.related ? this.data.related : this.data.name;
        result = this.getFieldValue(r, attr);
        
        if(result == undefined && this.data.default) result = this.data.default;
      }
      this.fieldval = result;      
    }
  }
}
</script>

<style scoped>
.border {
  border: 1px solid;
  border-radius: 0.375rem;
}
.pe-none {
  pointer-events: none;
}
.dropdown-content {
  max-height: 13em;
  overflow: auto;
}
.border-danger {
  border-color: hsl(348, 100%, 61%);
}
</style>
